(() => {
  if (window.__sachetsCoLinkFixesLoaded) return;
  window.__sachetsCoLinkFixesLoaded = true;

  const routeMap = new Map([
    ['/contact', '/pages/request-a-quote'],
    ['/quote', '/pages/request-a-quote'],
    ['/request-a-quote', '/pages/request-a-quote'],
    ['/pages/contact-old', '/pages/request-a-quote'],
    ['/pages/contact', '/pages/request-a-quote'],
    ['/pages/contact-sachetsco', '/pages/request-a-quote'],
    ['/pages/contact-us-sachetsco-sydney', '/pages/request-a-quote'],
    ['/pages/quote', '/pages/request-a-quote'],
    ['/pages/faq', '/pages/bulk-to-sachet-faq'],
    ['/pages/process', '/pages/bulk-to-sachet-process'],
    ['/pages/quality', '/pages/quality-compliance'],
    ['/pages/quality-compliance-statement', '/pages/quality-compliance'],
    ['/pages/privacy', '/pages/privacy-policy'],
    ['/pages/refund-policy', '/pages/returns-refunds-policy'],
    ['/pages/terms-of-use', '/pages/terms-conditions'],
    ['/pages/shop', '/pages/build-your-sachet-brand'],
    ['/pages/powder-sachets-1-30g', '/pages/powder-sachet-filling'],
    ['/pages/liquid-gel-sachets', '/pages/liquid-gel-sachet-filling'],
    ['/pages/liquid-gel-sachets-1-30ml', '/pages/liquid-gel-sachet-filling'],
    ['/pages/industrial-agricultural-sachets', '/pages/industries-industrial-agriculture'],
    ['/pages/sachet-case-studies-results-outcomes-sachetsco', '/pages/case-studies'],
    ['/pages/innovatine', '/pages/collagen-creatine-sachet-filling'],
    ['/pages/innovateine', '/pages/collagen-creatine-sachet-filling'],
    ['/pages/muscklatine', '/pages/collagen-creatine-sachet-filling'],
    ['/pages/muscleatine-1', '/pages/collagen-creatine-sachet-filling'],
    ['/pages/high-performance-sports-nutrition-sachets-with-99-9-pure-creatine-discover-our-tga-compliant-facility-custom-formulation-service', '/pages/collagen-creatine-sachet-filling'],
    ['/collections/all', '/pages/sample-kit'],
    ['/products/electrolyte-hydration-sticks', '/pages/electrolyte-hydration-sachets'],
    ['/products/protein-powder-sachets', '/pages/supplement-sachet-manufacturing'],
    ['/products/single-dose-face-masks', '/pages/liquid-gel-sachet-filling'],
    ['/products/serum-samples', '/pages/liquid-gel-sachet-filling'],
    ['/products/sunscreen-sachets', '/pages/liquid-gel-sachet-filling'],
    ['/products/hair-care-treatments', '/pages/liquid-gel-sachet-filling'],
    ['/products/creatine-monohydrate-sachets-100-x-5g', '/pages/collagen-creatine-sachet-filling'],
    ['/products/collagen-peptide-sachets-100-x-5g', '/pages/collagen-creatine-sachet-filling']
  ]);

  const internalHosts = new Set([
    window.location.hostname,
    'sachetsco.com',
    'www.sachetsco.com',
    'sachetsco.myshopify.com'
  ]);

  const phoneTextRules = [
    [/\+61[\s-]*427[\s-]*704[\s-]*222/g, '+61 2 9412 4604'],
    [/\+61427704222/g, '+61 2 9412 4604'],
    [/\b0427[\s-]*704[\s-]*222\b/g, '02 9412 4604'],
    [/\b0427704222\b/g, '02 9412 4604'],
    [/\b1300[\s-]*000[\s-]*000\b/g, '02 9412 4604'],
    [/\+61[\s-]*294[\s-]*124[\s-]*604/g, '+61 2 9412 4604']
  ];

  const normalisePhoneText = (value) =>
    phoneTextRules.reduce((result, [pattern, replacement]) => result.replace(pattern, replacement), value);

  const fixLink = (link) => {
    const raw = link.getAttribute('href');
    if (!raw) return;

    if (raw.toLowerCase().startsWith('tel:')) {
      const digits = raw.replace(/\D/g, '');
      if (['61427704222', '0427704222', '1300000000', '61294124604', '0294124604'].includes(digits)) {
        link.setAttribute('href', 'tel:+61294124604');
      }
      return;
    }

    if (/^(mailto:|sms:|javascript:|data:|#)/i.test(raw)) return;

    let url;
    try {
      url = new URL(raw, window.location.href);
    } catch (_) {
      return;
    }

    if (!internalHosts.has(url.hostname)) return;
    const replacement = routeMap.get(url.pathname);
    if (!replacement) return;

    link.setAttribute('href', `${replacement}${url.search}${url.hash}`);
  };

  const fixTextNode = (node) => {
    const parent = node.parentElement;
    if (!parent || parent.closest('script, style, noscript, textarea, template, [contenteditable="true"]')) return;
    const corrected = normalisePhoneText(node.nodeValue || '');
    if (corrected !== node.nodeValue) node.nodeValue = corrected;
  };

  const fixRoot = (root) => {
    if (!root) return;

    if (root.nodeType === Node.ELEMENT_NODE && root.matches('a[href]')) fixLink(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(fixLink);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) fixTextNode(node);
  };

  fixRoot(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) fixTextNode(node);
        if (node.nodeType === Node.ELEMENT_NODE) fixRoot(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
